import React from 'react';
import { connect } from 'react-redux';
import { PaymentMethodActivation } from './PaymentMethodActivation';
import { actions } from './PaymentMethodActivation.actions';
import {
    getActivationCode
} from './PaymentMethodActivation.selectors';

const PaymentMethodActivationComponent = connect(
    function mapStateToProps(state, ownProps) {
        return {
            email: state?.user?.email || '',
            loadingActivationCode: state.paymentDetails.loadingActivationCode,
            ...getActivationCode(state),
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            submitLinkConfirm: actions.submitLinkConfirm,
            searchMehod: actions.searchMehod,
            activationPaymentDetails: actions.activationPaymentDetails
        };
    },
)(PaymentMethodActivation);

export default PaymentMethodActivationComponent;
